import { Icon } from "../Icons";

export function RequirementsInstall() {
  return (
    <section className="section" id="requirements" style={{ background: "var(--bg-subtle)" }}>
      <div className="section-inner">
        <div className="section-header">
          <div className="eyebrow">04 · Requirements & install</div>
          <h2>Gateway-local by design.</h2>
          <p className="lede">
            Install through the Ignition Gateway. Processing stays on the gateway; the module does
            not need internet access to run.
          </p>
        </div>
        <div className="examples-grid" style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 24 }}>
          <div className="card" style={{ padding: 26 }}>
            <div className="eyebrow" style={{ marginBottom: 12, color: "var(--ink-2)" }}>
              REQUIREMENTS
            </div>
            <ul
              style={{
                listStyle: "none",
                margin: 0,
                padding: 0,
                display: "grid",
                gap: 10,
                fontSize: 14,
              }}
            >
              {[
                "Ignition 8.3.0+",
                "Install via Platform > Modules",
                "Linux, Windows, and macOS per-platform .modl downloads",
                "Signed .modl from Katenaria",
                "No outbound telemetry or cloud processing",
              ].map((t, i) => (
                <li key={i} style={{ display: "flex", gap: 10, color: "var(--ink-2)" }}>
                  <Icon.Check style={{ color: "var(--ok)", marginTop: 2, flex: "0 0 14px" }} />
                  {t}
                </li>
              ))}
            </ul>
          </div>
          <div className="card" style={{ padding: 26 }}>
            <div className="eyebrow" style={{ marginBottom: 12, color: "var(--ink-2)" }}>
              RUNTIME PATH
            </div>
            <p style={{ fontSize: 14, color: "var(--ink-2)", lineHeight: 1.6, margin: 0 }}>
              Write SQL pipelines in the Ignition UI. The native C++ engine runs them directly on
              the gateway, processing live tag messages and publishing derived signals back as
              Ignition tags.
            </p>
            <p style={{ fontSize: 14, color: "var(--ink-2)", lineHeight: 1.6, margin: "10px 0 0" }}>
              This includes moving averages, rate-of-change, FIR filters, and windowed
              aggregations — complex signal processing expressed as plain SQL over live tag
              streams, without writing a single line of Jython.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}
